/**
 * Error Handler — CV Creator
 *
 * Reporte manual de excepciones JavaScript a PostHog (producción).
 * Usar en bloques try/catch cuando el error se maneja en UI y no se re-lanza.
 *
 * @package CodersLink_CVCreator
 */
var ErrorHandler = (function () {
  "use strict";

  /**
   * Reporta una excepción capturada a PostHog.
   *
   * @param {Error|string|*} error Error capturado
   * @param {Object} [properties] Contexto adicional (context, step, etc.)
   */
  function reportException(error, properties) {
    if (typeof cvcreatorCaptureException === "function") {
      cvcreatorCaptureException(error, properties);
      return;
    }

    if (
      window.CVCreatorAnalytics &&
      typeof window.CVCreatorAnalytics.captureException === "function"
    ) {
      window.CVCreatorAnalytics.captureException(error, properties);
    }
  }

  /**
   * Añade un breadcrumb al timeline de la excepción en Session Replay.
   * Registrar pasos antes de reportException para que aparezcan en el replay.
   *
   * @param {string} message Descripción del paso
   * @param {Object} [properties] Metadatos opcionales
   */
  function addExceptionStep(message, properties) {
    if (typeof cvcreatorAddExceptionStep === "function") {
      cvcreatorAddExceptionStep(message, properties);
      return;
    }

    if (
      window.CVCreatorAnalytics &&
      typeof window.CVCreatorAnalytics.addExceptionStep === "function"
    ) {
      window.CVCreatorAnalytics.addExceptionStep(message, properties);
    }
  }

  return {
    reportException: reportException,
    addExceptionStep: addExceptionStep,
  };
})();
